<template>
  <section
    class="pa-6"
    aria-labelledby="profile-install-title"
  >
    <h2
      id="profile-install-title"
      class="text-h6 mb-2"
    >
      Self Biography app
    </h2>
    <p>Keep Self Biography on your home screen or desktop for quick access to your stories.</p>
    <v-btn
      color="primary"
      outlined
      @click="openInstallDialog"
    >
      <v-icon left>
        {{ mdiDownload }}
      </v-icon>
      {{ pwa.installed ? 'App installation' : 'Install app' }}
    </v-btn>
  </section>
</template>

<script>
import { mdiDownload } from '@mdi/js'
import { pwaState, openInstallDialog } from '@/services/pwa'

export default {
  data: () => ({ pwa: pwaState, mdiDownload }),
  methods: { openInstallDialog },
}
</script>
